import { LOCAL_SUPER_USER } from '@/helpers/constants'
import { useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useUserPermission } from '@/hooks/usePermission'
import { useUserRoles } from '@/hooks/useUserRoles'
import { computed } from 'vue'

export const AI_ASSISTANTS_FEATURE_FLAG = 'enable_ai_assistants'

/**
 * The route guard already gates the section on flag and accessible; this hook is
 * for finer decisions inside it (add/delete controls, admin-only settings).
 */
export const useAiAssistantsAccess = () => {
  const { isEnabled: hasFeatureFlag } = useFeatureFlag(
    AI_ASSISTANTS_FEATURE_FLAG
  )
  const { canManage } = useUserPermission('ai_assistants')
  const { hasRole, isAdmin, isSuperadmin, isSuperuser } = useUserRoles()

  // Flags are undefined until the user and company have loaded
  const isEnabled = computed(() => hasFeatureFlag.value ?? false)

  const canEditGeneralKnowledge = computed(
    () =>
      isAdmin.value ||
      isSuperadmin.value ||
      isSuperuser.value ||
      hasRole(LOCAL_SUPER_USER)
  )

  return { isEnabled, canManage, canEditGeneralKnowledge }
}
